/* eslint-disable react/require-default-props,react/no-array-index-key */

import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { SubscriptionPlanTile } from './SubscriptionPlanTile';
import './PortalSubscriptionPlans.scss';

// eslint-disable-next-line react/prefer-stateless-function
export class PortalSubscriptionPlans extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    data: ImmutablePropTypes.mapContains({
      tagline: PropTypes.string,
      plans: ImmutablePropTypes.list,
      footnote: PropTypes.string,
    }),
    themeData: ImmutablePropTypes.map,
  };

  render() {
    const { title, data, themeData } = this.props;
    const brandColor = themeData.get('brand-color', '#394080'); // default teach.com.au colors

    return (
      <portal-subscription-plans>
        <div className="row portal-section">
          <div className="columns small-11 small-centered medium-10 medium-centered">
            <h2>
              <span>{title}</span>
            </h2>
            <h4>{data.get('tagline')}</h4>
            <div className="row plans">
              {data.get('plans').map((plan, index) => (
                <SubscriptionPlanTile
                  key={`plan-${index}`}
                  {...plan.toJS()}
                  {...{ brandColor }}
                />
              ))}
            </div>
            <h4>Subscription renews automatically. Cancel anytime.</h4>
            <center>
              {data
                .get('footnote', '')
                .split('\n')
                .map((line, i) => (
                  <div key={`line-${i}`}>{line}</div>
                ))}
            </center>
          </div>
        </div>
      </portal-subscription-plans>
    );
  }
}
